import { gql } from "@apollo/client"

export const AFFILIATE_APPLICATION_ELIGIBILITY_QUERY = gql`
  query AffiliateApplicationEligibility {
    affiliateApplicationEligibility {
      eligible
      pathEligible
      blockingReasons
      backgroundCheck {
        complete
      }
      qualifyingLevel {
        complete
        expired
      }
      age {
        complete
        dateOfBirth
      }
    }
  }
`
